import quickGuideDetailsLocale from './en.json'

const en = {
  quickGuideDetails: quickGuideDetailsLocale,
}

export default en
